(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-cross-sell"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-custom-cross-sell]:not([data-cross-sell-ready])';

    const getPanels = (root) => {
      const panels = [];

      if (root instanceof Element && root.matches(selector)) {
        panels.push(root);
      }

      if (root.querySelectorAll) {
        root.querySelectorAll(selector).forEach((panel) => panels.push(panel));
      }

      return panels;
    };

    const initPanel = (panel) => {
      const items = Array.from(panel.querySelectorAll('[data-cross-sell-item]'));
      const previousButton = panel.querySelector('[data-cross-sell-previous]');
      const nextButton = panel.querySelector('[data-cross-sell-next]');
      const status = panel.querySelector('[data-cross-sell-status]');
      const pageSize = Number(panel.dataset.crossSellPageSize) || 4;
      const pageCount = Math.ceil(items.length / pageSize);

      panel.dataset.crossSellReady = 'true';

      if (pageCount <= 1 || !previousButton || !nextButton) {
        return;
      }

      let currentPage = 0;

      const renderPage = () => {
        const startIndex = currentPage * pageSize;
        const endIndex = startIndex + pageSize;

        items.forEach((item, index) => {
          item.hidden = index < startIndex || index >= endIndex;
        });

        if (status) {
          status.textContent = `Zestaw ${currentPage + 1} z ${pageCount}`;
        }
      };

      previousButton.addEventListener('click', () => {
        currentPage = (currentPage - 1 + pageCount) % pageCount;
        renderPage();
      });

      nextButton.addEventListener('click', () => {
        currentPage = (currentPage + 1) % pageCount;
        renderPage();
      });

      renderPage();
    };

    const init = (root = document) => {
      getPanels(root).forEach(initPanel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
